import i18n from '@signavio/i18n';
import { Modal } from '@signavio/ui';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Alert({
  children,
  onDismiss,
  title
}) {
  return /*#__PURE__*/_jsx(Modal, {
    title: title,
    confirmLabel: i18n('Ok'),
    onRequestClose: onDismiss,
    onConfirm: onDismiss,
    children: children
  });
}